import { HqApiService } from 'hq/services/hqApiService';
import { Site } from 'shared/hooks';
import { PaymentsFilters } from 'hq/components/views/finance/payments/hooks/use-payments-filters.types';
import {
  PaymentInfiniteResponse,
  paymentInfiniteResponseSchema,
  PaymentUsersInfiniteResponse,
  paymentUsersInfiniteResponseSchema,
} from './payments.schema';
import { PaymentUsersFilters } from '../../../hq/components/views/finance/payment-users/hooks/use-payment-users.types';

export class PaymentsService {
  constructor(private readonly hqApiService: HqApiService) {}

  public async getPaginatedPayments(
    site: Site,
    params: { page: number; pageSize: number } & PaymentsFilters
  ) {
    const response = await this.getPaginatedPaymentsImpl(site, params);
    return paymentInfiniteResponseSchema.parse(response);
  }

  public async getPaginatedPaymentUsers(
    site: Site,
    page: number,
    pageSize: number,
    filters: PaymentUsersFilters
  ) {
    const response = await this.getPaginatedPaymentUsersImpl(
      site,
      page,
      pageSize,
      filters.worker,
      filters.iban,
      filters.state
    );
    return paymentUsersInfiniteResponseSchema.parse(response);
  }

  public async blockUser(site: Site, flexWorkerId: string) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.update({
          path: `payment-users/block/${flexWorkerId}`,
        });
      default:
        throw new Error('Not implemented');
    }
  }
  public async unblockUser(site: Site, flexWorkerId: string) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.update({
          path: `payment-users/unblock/${flexWorkerId}`,
        });
      default:
        throw new Error('Not implemented');
    }
  }

  public async blockPayment(site: Site, paymentId: string) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.update({
          path: `payments/block/${paymentId}`,
        });
      default:
        throw new Error('Not implemented');
    }
  }

  public async unblockPayment(site: Site, paymentId: string) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.update({
          path: `payments/unblock/${paymentId}`,
        });
      default:
        throw new Error('Not implemented');
    }
  }

  public async resendPayment(site: Site, paymentId: string) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.update({
          path: `payments/resend/${paymentId}`,
        });
      default:
        throw new Error('Not implemented');
    }
  }

  public async forcePayPayment(site: Site, paymentId: string) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.update({
          path: `payments/force/${paymentId}`,
        });
      default:
        throw new Error('Not implemented');
    }
  }

  private async getPaginatedPaymentsImpl(
    site: Site,
    params: { page: number; pageSize: number } & PaymentsFilters
  ) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.get<PaymentInfiniteResponse>({
          path: `payments`,
          params,
        });
      default:
        throw new Error('Not implemented');
    }
  }

  private async getPaginatedPaymentUsersImpl(
    site: Site,
    page: number,
    pageSize: number,
    workerId?: string,
    iban?: string,
    state?: string
  ) {
    switch (site) {
      case 'hq':
        return await this.hqApiService.get<PaymentUsersInfiniteResponse>({
          path: `payment-users`,
          params: {
            page,
            pageSize,
            workerId,
            iban,
            state,
          },
        });
      default:
        throw new Error('Not implemented');
    }
  }
}
